'use client';
import useViewModeState, { ViewMode } from './useViewModeState';

export default function OnlyViewMode({
    viewMode: _viewMode,
    children,
}: React.PropsWithChildren<{ viewMode: ViewMode }>) {
    const { viewMode } = useViewModeState();

    return viewMode === _viewMode && children;
}
